<template>
  <the-navigation></the-navigation>

  <router-view></router-view>

  <the-Footer></the-Footer>
  <!-- <CookieBanner /> -->
</template>

<script>
import { useRouter } from 'vue-router';
import { onMounted, watch, nextTick } from 'vue';
import TheNavigation from './components/Layout/TheNavigation.vue';
import TheFooter from './components/Layout/TheFooter.vue';
// import CookieBanner from './components/UI/CookieBanner.vue';

export default {
  components: {
    TheNavigation,
    TheFooter,
    // CookieBanner,
  },
  setup() {
    const router = useRouter();

    // Function to load appropriate CSS based on route
    const loadCSSForRoute = () => {
      const currentPath = router.currentRoute.value.path.toLowerCase();
      const isHomePage = currentPath === '/' || currentPath === '/home';

      // Remove existing links to avoid duplicates
      document.querySelectorAll('link[data-route-css]').forEach(link => link.remove());

      // Load appropriate CSS
      if (isHomePage) {
        // Load only home.css for home page
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/assets/css/home.css';
        link.setAttribute('data-route-css', 'true');
        document.head.appendChild(link);
      } else {
        // Load interior.css for all other pages
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/assets/css/interior.css';
        link.setAttribute('data-route-css', 'true');
        document.head.appendChild(link);
      }
    };

    // Function to setup scroll reveal for .reveal elements
    const setupScrollReveal = () => {
      const obs = new IntersectionObserver(entries => {
        entries.forEach(e => { 
          if (e.isIntersecting) {
            e.target.classList.add('visible');
          }
        });
      }, { threshold: 0.08 });
      
      // Observe all .reveal elements
      document.querySelectorAll('.reveal').forEach(el => obs.observe(el));
    };

    // Load CSS on component mount
    onMounted(() => {
      loadCSSForRoute();
      // Wait for DOM to be fully rendered before setting up scroll reveal
      nextTick(() => {
        setupScrollReveal();
      });
    });

    // Watch for route changes
    watch(
      () => router.currentRoute.value.path,
      () => {
        loadCSSForRoute();
        // Setup scroll reveal again after route change and DOM update
        nextTick(() => {
          setupScrollReveal();
        });
      }
    );

    return {};
  }
};
</script>

<style>
* {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
}

body {
  margin: 0;
}
</style>
